import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.page.html',
  styleUrls: ['./filters.page.scss'],
})
export class FiltersPage implements OnInit {

  public name = null;
  public date_from = null;
  public date_to = null;
  public employee_name = null;
  is_supervisor = false;
  is_new_work_permit = false;
  type = null;
  status_id = null;

  constructor(private modalController:ModalController, private navParams: NavParams) {
    let filters = navParams.get('filters');
    this.is_supervisor = navParams.get('is_supervisor');
    this.is_new_work_permit = navParams.get('is_new_work_permit');
    this.type = navParams.get('type');
    this.filtros_formulario(filters);
  }

  ngOnInit() {
  }

  // Poner el valor de cada campo en el formulario
  filtros_formulario(filters){
    if(filters['name'] != undefined){
      this.name = filters['name'];
    }
    if(filters['date_from'] != undefined){
      this.date_from = filters['date_from'];
    }
    if(filters['date_to'] != undefined){
      this.date_to = filters['date_to'];
    }
    if(filters['employee_name'] != undefined){
      this.employee_name = filters['employee_name'];
    }
    if(filters['status_id'] != undefined){
      this.status_id = filters['status_id'];
    }
  }

  guardar(formulario:NgForm){
    console.log(formulario.value);
    this.modalController.dismiss({
      'dismissed': true,
      'with_filters': true,
      'filters': formulario.value
    });
  }

  reset(formulario:NgForm){
    formulario.reset();
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      'dismissed': true,
      'with_filters': false,
    });
  }

}
